'use strict';

import {gsap} from 'gsap';
import 'scrollTo';
import 'moment';

import Loader from '../../../_modules/loader/loader';
import ProductDetails from '../../../_modules/product-details/product-details';
import PoNumber from '../../../_modules/po-number/po-number';
import CarerDetail from '../../../_modules/carer-detail/carer-detail';
import SummaryDashboard from '../../../_modules/summary-dashboard/summary-dashboard';
import SohModal from '../../../_modules/soh-modal/soh-modal';
import FirstOrder  from '../../../_modules/first-order/first-order';
// import OrderOverride  from '../../../_modules/order-override/order-override';

import { debounce, isFieldEmpty, isDobEmpty, isValidEmail, displayErrors, isValidDob, delay, decodeResponse, goToNextSection, displayInputError, initiateAutoCompleteSuburb } from './_helper';
import { displayPayContinue } from './_payment';
import { toaster } from './_material';
import { carerDetails, cloneCarerRow, isCarerFormValid } from '../../../_modules/carer-detail/carer-detail';


let $header = $('.header'),
    $dashboard = $('section.dashboard'),
    $suggestions = $('.form--suggestions'),
    $institutionId = $('#InstitutionId'),
    $hcpWorkplaceId = $('#HcpWorkplaceId'),
    $title = $('#Title'),
    $firstName = $('#FirstName'),
    $lastName = $('#LastName'),
    $dobDay = $('#DobDay'),
    $dobMonth = $('#DobMonth'),
    $dobYear = $('#DobYear'),
    $gender = $('#Gender'),
    $clientId = $('#ClientId'),
    $isEligibleForFreeDelivery = $('#IsEligibleForFreeDelivery'),
    $gst = $('#gst'),
    $deliveryNotes = $('#DeliveryNotes'),
    $clientUR = $('#ClientUR'),
    $doNotCall = $('#IsDoNotCallOpted'),
    $primaryContact = $('#PrimaryContact'),
    $primaryNumber = $('#PrimaryNumber'),
    $secondaryNumber = $('#SecondaryNumber'),
    $emailAddress = $('#EmailAddress'),
    $patientHaveCarer = $('#PatientHaveCarer'),
    $carerFirstName = $('.carer-details__row .CarerFirstName'),
    $carerLastName = $('.carer-details__row .CarerLastName'),
    $carerPrimaryNumber = $('.carer-details__row .CarerPrimaryNumber'),
    $carerEmailAddress = $('.carer-details__row .CarerEmailAddress'),
    $carerRelationshipToClient = $('#CarerRelationshipToClient'),
    $carerRelationshipToClientDefaultOption = $('select#CarerRelationshipToClient > option.defaultOption'),
    $carerRelationshipToClientErrorMessage = $('.select-wrapper span.error'),
    $printedVersionSupplied = $("#PrintedVersionSupplied"),
    $clientDetailsConsented = $("#ClientDetailsConsented"),
    $clientLogisticsProviderAgreed = $("#ClientLogisticsProviderAgreed"),
    $clientPersonalDataTransferAgreed = $("#ClientPersonalDataTransferAgreed"),
    $multiStepsNav = $('.multi-steps-nav'),
    $addressLine1 = $('#street_number'),
    $addressLine2 = $('#route'),
    $addressSuburb = $('#locality'),
    $suburbStatePostcode = $('#SuburbStatePostcode'),
    $addressPostCode = $('#postal_code'),
    $addressState = $('#administrative_area_level_1'),
    $addressAdditionalNotes = $('#AdditionalAddressNotes'),
    $firstDeliveryCartons = $('#first-delivery__cartons'),
    $firstRowDelivery = $('.form--delivery-details table tr:first-child'),
    $receiptDeliveryFee = $('.receipt--delivery-total'),
    $firstDeliveryFree = $('#FirstDeliveryFree'),
    $allDeliveryFree = $('#FreeDelivery'),
    $requiresHcpApproval = $('#RequiresHcpApproval'),
    $disableClientNotifications = $('#DisableClientNotifications'),
    $createRegimenForm = $('#create-regimen-form'),
    $startToday = $('#StartToday'),
    $startLater = $('#StartLater'),
    $startLaterDate = $('.regimen-start--later__input'),
    $startDateInput = $('#StartDate'),
    startDate = moment().format('DD-MM-YYYY'),
    $urgentOrder = $('#UrgentOrder'),
    $carerDetailsForm = $('.container--carer-details'),
    //following 3 items are displayed on customer service dashboard
    $InstitutionDropdown = $('#InstitutionDropdown'),
    $HcpDropdown = $('#HcpDropdown'),
    $dashboardCustService = $('#institution-hcp-details'),
    $paymentDelivery = $('#payment-delivery'),
    $counter = $('.counter'),
    $selectCtaPayment,
    formSuggestionTmp = '',
    $regimens = '',
    isCarerPrimaryContact = false,
    isAccountCreated = false,
    isPayNow = true,
    hasCarer = false,
    isAnim = false,
    isSkipStockCheck = false,
    overrideCheckedOrderClicked = false,
    sectionInd = 1,
    obj = {},
    dataParams = {},
    values ={},
    _data = [],
    _filteredData = [],
    _isInvalid = [],
    formSuggestionHtml = '',
    popupInterruptRegimenHtml = '',
    popupInterruptRegimenTmp = '',
    loader,
    isCreateRegimen= sessionStorage.getItem('isCreateRegimen'),
    isNdis = $(".is-ndis").length > 0,
    $ndisEligibility = $('#NDISEligibility'),
    $tenderSetting = $("#TenderSetting"),
    _tenderSetting = $tenderSetting.length > 0 ? JSON.parse($tenderSetting.val()) : null;

$(() => {
    if (!$dashboard.length) {
        return false;
    }

    let isNdisPayLater = function(isContinue) {
        //let noOfOrders = $(".product-details__header .counter-value").val();
        displayPayContinue(isNdis ? true : isContinue);
    }

    /* sessionStorage needed to define whether
    ** - a regimen was created and user clicks on "clear all"
    ** - user wants access page by clicking on "js-new-regimen"
    */
    if (isCreateRegimen === 'true') {
        $('.main-nav').slideUp({
            duration: 500,
            easing: 'easeInOutExpo'
        });

        $('.multi-steps-nav').slideDown({
            duration: 500,
            easing: 'easeInOutExpo'
        });
        $('.regime-status').fadeOut();
    }

    // Set to false to correctly reload page.
    sessionStorage.setItem('isCreateRegimen', 'false');

    // Initialize Products.
    let productDetails = new ProductDetails();
    productDetails.init();

    //Init Carer Details
    let carerDetailsObj = new CarerDetail();
    carerDetailsObj.init();

    //Init Summary
    let summaryDetails = new SummaryDashboard();

    formSuggestionTmp = doT.template($('#form-suggestion-tmp').html());
    popupInterruptRegimenTmp = doT.template($('#popup-regimen-interrupt-tmp').html());

    // Put Loader in a variable
    loader = new Loader();


    // //Init Summary
    // let orderOverrideObj = new OrderOverride();
    // orderOverrideObj.init();

    // Event listeners to do their magic
    $title.on('change', function (e) {
        changeToRegimen();
    });

    $firstName.on('keyup', function (e) {
        delay( "check date", function(){ populateSuggestions(); } ,600);
    });

    $lastName.on('keyup', function (e) {
        delay( "check date", function(){ populateSuggestions(); } ,600);
    });

    $('.dob').on('keyup', '.floating-input', function (e) {
        let $this = $(this),
            $parent = $this.parent(),
            $grandParent = $parent.parent(),
            maxLength = $this.attr('maxlength');

        if (!(e.keyCode == 16 || e.keyCode == 9)) {
            if ($this.val().length == maxLength) {
                $grandParent.next().find('.floating-input').focus();
            }
        }

        if (!isDobEmpty()) {
            delay( "check date", function(){ populateSuggestions(); } ,600);
        }
    });

    $gender.on('change', function () {
        if (!isFieldEmpty($firstName) && !isFieldEmpty($lastName) && !isDobEmpty()) {
            $suggestions.removeClass('active');
        }
    });

    $patientHaveCarer.on('change', function () {
        let $this = $(this);

        hasCarer = $this.prop('checked');

        if (hasCarer) {
            $primaryContact
                .parent()
                .stop().clearQueue()
                .slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            $this.prop('checked', true);

            $('.form--carer-details').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
        } else {
            $primaryContact
                .parent()
                .stop().clearQueue()
                .slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            $this.prop('checked', false);

            $('.form--carer-details').slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
        }
    });
    
    $(document).ready(function(e){
        initiateAutoCompleteSuburb($suburbStatePostcode, $addressSuburb, $addressPostCode, $addressState);
    });

    /*
    *   TODO refactor
    *   this function is being repeated in different files (_new-patient.js and _dashboard.js)
    *   most likely to be present in other files as well.
    *   Consider refactor this.
    * */
    $primaryContact.on('change', function () {
        let $this = $(this),
            isChecked = $this.prop('checked');

        isCarerPrimaryContact = isChecked;
        let isNewRecord = isFieldEmpty($clientId);

        if (isCarerPrimaryContact) {
            $carerFirstName.prev().text($carerFirstName.prev().text() + ' *');
            $carerLastName.prev().text($carerLastName.prev().text() + ' *');
            $carerPrimaryNumber.prev().text($carerPrimaryNumber.prev().text() + ' *');
            $carerRelationshipToClientDefaultOption.text($carerRelationshipToClient.find('option.defaultOption').text() + ' *');

            if(isNewRecord) {
                $carerEmailAddress.prev().text($carerEmailAddress.prev().text() + ' *');
                $emailAddress.prev().text($emailAddress.prev().text().replace(' *', ''));
                
                //removed as part of urgent request by Lucy: 250Jun-2020
                //$emailAddress.attr('required', false);
                //$carerEmailAddress.attr('required', true);
            }

            $primaryNumber.prev().text($primaryNumber.prev().text().replace(' *', ''));
            $primaryNumber.attr('required', false);
            
            $carerFirstName.attr('required', true);
            $carerLastName.attr('required', true);
            $carerPrimaryNumber.attr('required', true);
            $carerRelationshipToClient.attr('required', true);

        } else {
            $carerFirstName.prev().text($carerFirstName.prev().text().replace(' *', ''));
            $carerLastName.prev().text($carerLastName.prev().text().replace(' *', ''));
            $carerPrimaryNumber.prev().text($carerPrimaryNumber.prev().text().replace(' *', ''));
            $carerRelationshipToClientDefaultOption.text($carerRelationshipToClient.find('option.defaultOption').text().replace(' *', ''));
            $carerRelationshipToClientErrorMessage.css('display', 'none');

            $primaryNumber.prev().text($primaryNumber.prev().text() + ' *');
            $primaryNumber.attr('required', true);

            $carerFirstName.attr('required', false);
            $carerLastName.attr('required', false);
            $carerPrimaryNumber.attr('required', false);
            $carerRelationshipToClient.attr('required', false);

            if(isNewRecord) {
                $carerEmailAddress.prev().text($carerEmailAddress.prev().text().replace(' *', ''));
                $emailAddress.prev().text($emailAddress.prev().text() + ' *');
                
                //removed as part of urgent request by Lucy: 250Jun-2020
                //$emailAddress.attr('required', true);
                //$carerEmailAddress.attr('required', false);
            }
        }
    });

    // If they select ‘urgent’ then they should not be able to select 'do not call'.
    $doNotCall.on('change', function () {
        let $this = $(this);

        if($this.prop('checked')) {
            $('.urgent-order__container').hide();
        } else {
            $('.urgent-order__container').show();
        }
    });


    // If they have selected ‘do not call’ then they should not be able to select ‘urgent’.
    // nb: urgent order also depends on the payment option
    $urgentOrder.on('change', function () {
        let $this = $(this);

        if ($this.prop('checked')) {
            $doNotCall.parent().hide();
        } else {
            $doNotCall.parent().show();
        }
    });


    $('body').on('click', '.js-populate-data', function (e) {
        let $this = $(this),
            $ind = $this.data('index'),
            isMobileDevice = Modernizr.mq('(max-width: 767px)');

        if(_data[$ind].NumberOfActiveRegimens > 0){

            obj = {},
            popupInterruptRegimenHtml = '';

            obj = {
                "regimens": _filteredData[$ind].NumberOfActiveRegimens,
                "regimenUrl": _filteredData[$ind].RedirectUrl,
                "fullName": _filteredData[$ind].Details.FirstName + " " + _filteredData[$ind].Details.LastName
            };

            popupInterruptRegimenHtml += popupInterruptRegimenTmp(obj);

            $('.popup-regimen-interrupt').html(popupInterruptRegimenHtml);

            $.fancybox.open('#regimen-active', {
                autoSize: false,
                closeBtn: false,
                fitToView: false,
                height: isMobileDevice == true ? 300 : 200,
                width: isMobileDevice == true ? 250 : 500,
                padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
                type: 'inline',
                wrapCSS: 'modal',
                helpers: {
                    overlay:{
                        closeClick: true
                    }
                },
                beforeClose: function(){
                    populateDetails($ind);
                }
            });

        }else{
            populateDetails($ind);
        }

        $suggestions.removeClass('active');

        $('.js-edit-active-regimen').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });

        $('.js-create-other-regimen').on('click', function (e) {
            $.fancybox.close();
        });
    });
    // Clear all btn
    $('.js-reset-client-form').on('click', function(e) {
        e.preventDefault();

        let isCreatedRegimen = $('.regime-status').is(':hidden');

        loader = new Loader();

        loader.fadeIn();

        if (isCreatedRegimen) {
            sessionStorage.setItem('isCreateRegimen', 'true');
        }

        setTimeout(function(){ window.location.reload(); }, 250);

    });

    $('.js-jump-section').on('click', function (e) {
        e.preventDefault();

        if (isAnim) {
            return false;
        }

        let $this = $(this),
            $parent = $this.parent(),
            el;

        sectionInd = $parent.index();

        switch (sectionInd) {
            case 1:
                el = $('#patient-details');
                break;
            case 2:
                el = $('#contact-details');
                break;
            case 3:
                el = $('#carer-details');
                break;
            case 4:
                el = $('.form--patient-consent');
                break;
            case 5:
                el = $('#regimen-date');
                break;
            case 6:
                el = $('#regimen-products');
                break;
            case 7:
                el = $('#delivery-details');
                break;
            case 8:
                el = $('#payment-details');
                break;
        }

        gsap.to(window, {
            duration: 1,
            scrollTo: {
                y: el.offset().top - $header.outerHeight() - parseInt($header.css('top')),
                ease: "expo.inOut"
            },
            onComplete: function () {
                isAnim = false;
            }
        });
    });


    $('.js-set-patient-details').on('click', function (e) {
        e.preventDefault();

        if (isAnim) {
            return false;
        }


        _isInvalid = [];

        if ($hcpWorkplaceId.length && isFieldEmpty($hcpWorkplaceId)) {
            _isInvalid.push(0);
        }

        if ($title.val() == '') {
            $title
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (isFieldEmpty($firstName)) {
            $firstName
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (isFieldEmpty($lastName)) {
            $lastName
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (isValidDob()) {
            $dobDay.parent().removeClass('incomplete');
            $dobMonth.parent().removeClass('incomplete');
            $dobYear.parent().removeClass('incomplete');

            $('.dob .error').fadeOut({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

        } else {
            $dobDay.parent().addClass('incomplete');
            $dobMonth.parent().addClass('incomplete');
            $dobYear.parent().addClass('incomplete');

            $('.dob .error').fadeIn({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if ($gender.val() == '') {
            $gender
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if($clientUR.data('is-required') == true && $clientUR.val() == ''){
           $clientUR
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            _isInvalid.push(0);
        }

        
        if($ndisEligibility.val() == ''){
            $ndisEligibility
                 .parent().addClass('incomplete')
                 .find('.error').slideDown({
                     duration: 500,
                     easing: 'easeOutExpo',
                     queue: false
                 });
 
             _isInvalid.push(0);
         }

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {
            _isInvalid = [];

            $(this).removeClass('error');

            toggleProgressBar(2);
            goToNextSection('#contact-details');

            summaryDetails.displaySummary('patient');
            productDetails.getAllProducts(true, false);
        }
    });

    $('.js-set-contact-details').on('click', function (e) {
        e.preventDefault();


        if (isAnim) {
            return false;
        }

        var phoneRegEx = /^[0-9]{8,10}$/;

        _isInvalid = [];

        if($primaryNumber.prop('required')){
            if (isFieldEmpty($primaryNumber) || !$primaryNumber.val().match(phoneRegEx)) {
                $primaryNumber
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }
        }

        if (!isFieldEmpty($secondaryNumber) && !$secondaryNumber.val().match(phoneRegEx)){
            $secondaryNumber
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if(isFieldEmpty($clientId) && $emailAddress.prop('required')) {
            //check if its a new record
            //check if field is mandatory. It could be optional if patient has primary carer
            //if field is empty or invalid email, throw error..
            if (isFieldEmpty($emailAddress) || !isValidEmail($emailAddress.val())) {
                $emailAddress
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }
        } else {
            //this means its optional, only throw error if its not empty and invalid
            if (!isValidEmail($emailAddress.val()) && !isFieldEmpty($emailAddress)){
                $emailAddress
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }
        }

        if(isCarerFormValid().length > 0){
            _isInvalid.push(0);
        }

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            $(this)
                .siblings('.validation--message')
                .slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
            return false;
        } else {
            _isInvalid = [];

            $(this).removeClass('error');
            $(this)
                .siblings('.validation--message')
                .slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
            $('#contact-details').addClass('completed');

            toggleProgressBar(3);
            goToNextSection('#patient-content');

            summaryDetails.displaySummary('contact-details');

            if ($patientHaveCarer.prop('checked')) {
                summaryDetails.displaySummary('carer-details');
            }
            // displayContactSummary();
        }
    });

    $('.carer-details__row input').on('blur', function () {

        summaryDetails.displaySummary('carer-details');
    });
    
    let chkboxValidation = function($chkBox){
        if($chkBox.prop("checked")) {
            $chkBox.parent().removeClass('error');
            return true;
        } else {
            $chkBox.parent().addClass('error');
            return false;
        }
    }

    $('.js-create-patient-account').on('click', function (e) {
        e.preventDefault();

        if (isAccountCreated || isAnim) {
            return false;
        }

        //todo refactor as there are a few function doing the same
        if ($startToday.is(':checked')){
            startDate = moment().format('DD-MM-YYYY');
            $startDateInput.val(startDate);
        }

        _isInvalid = [];

        let isChk1 = chkboxValidation($printedVersionSupplied),
            isChk2 = chkboxValidation($clientDetailsConsented),
            isChk3 = chkboxValidation($clientLogisticsProviderAgreed);

        if (!isChk1 ||
            !isChk2 ||
            !isChk3
            //|| !$clientPersonalDataTransferAgreed.prop('checked')
            ) {
            _isInvalid.push(0);
        }

        if (_isInvalid.length > 0) {
            toaster('You must agree to all Terms, Conditions and Privacy to continue.', 'error');
            $(this).addClass('error');
            return false;
        } else {
            _isInvalid = [];

            $(this).removeClass('error');
            toggleProgressBar(4);
            // goToNextSection('#regimen-date');
            goToNextSection('#delivery-details');

            // displaySummary('.summary--consent-details');
            return;
        }
    });

    /* Define start date for a regimen. Default date is today.
    ** Need to change expiry date and display payment buttons accordingly
    */
    $startToday.on('change', function(){
        $startLaterDate.fadeOut();
        productDetails.updateProducts();

        $('.start-today__disclaimer')
            .slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        //todo refactor as there are a few function doing the same
        if ($startToday.is(':checked')){
            startDate = moment().format('DD-MM-YYYY');
            $startDateInput.val(startDate);
        }

        isNdisPayLater(false);
    });

    //Display datepicker if Start Later is selected
    $startLater.on('change', function(){
        $startLaterDate.fadeIn();

        $startDateInput.val('');

        //todo refactor as there are a few function doing the same
        if ($startLater.is(':checked')) {
            startDate = $startDateInput.val();
        }

        $('.start-today__disclaimer')
            .slideUp({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        // displayPayContinue(true);
        isNdisPayLater(isContinue);
    });

    /* if CS requires HPC approval, payment will be done afterwards.
    ** Display "continue" button in the payment section
    */
    $requiresHcpApproval.on('change', function(){
        if($(this).prop('checked') || $startLater.prop('checked'))
            displayPayContinue(true);
        else
            displayPayContinue(false);
    });

    //Update expiry date if different date is selected
    $('body').on('change', '.regimen-datepicker', function(e) {

        productDetails.updateProducts();
        // startDate = $startDateInput.val();
        // $('.summary__regimen-date').text(startDate);
    });

    $('.js-set-regimen-date').on('click', function (e){
        e.preventDefault();

        let isStartLater = $startLater.prop('checked');

        if (isAnim) {
            return false;
        }

        if(isStartLater && isFieldEmpty($startDateInput)){
            $(this)
                .addClass('error')
                .parent()
                .find('.validation--message')
                .slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            return false;
        }
        else{
            $(this)
                .removeClass('error')
                .parent()
                .find('.validation--message')
                .slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            toggleProgressBar(5);
            goToNextSection('#regimen-products');

            summaryDetails.displaySummary('regimen-date');
        }
    });

    //updating Regimen summary start date, when input changes.
    $('.form--start-regimen input').on('change', function () {
        summaryDetails.displaySummary('regimen-date');
    });

    $('.js-confirm-order').on('click', function (e) {
        e.preventDefault();

        let isProductSelected = $('.phase--wrapper.active .product-details__row').length;

        if (isAnim) {
            return false;
        }

        if (!isProductSelected) {
            $(this).addClass('error');
            return false;
        }
        else {
            $(this).removeClass('error');

            toggleProgressBar(6);
            goToNextSection('#patient-details');
            summaryDetails.displaySummary('regimen-notes');
            summaryDetails.displaySummary('products');
        }
    });

    
    $('.js-confirm-plan').on('click', function (e) {
        e.preventDefault();

        let isProductSelected = $('.phase--wrapper.active .product-details__row').length;

        if (isAnim) {
            return false;
        }

        if (!isProductSelected) {
            $(this).addClass('error');
            return false;
        }
        else {
            $(this).removeClass('error');

            toggleProgressBar(6);
            goToNextSection('#regimen-notes');
            summaryDetails.displaySummary('regimen-notes');
            summaryDetails.displaySummary('products');
        }
    });

    $('#regimen-products').on('change', function () {
        summaryDetails.displaySummary('regimen-notes');
        summaryDetails.displaySummary('products');
    });

    $('.js-set-delivery-payment').on('click', function(e) {
        e.preventDefault();

        if (isAnim) {
            return false;
        }

        _isInvalid = [];

        if (isFieldEmpty($addressLine1)) {
            $addressLine1
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (isFieldEmpty($suburbStatePostcode)) {
            $suburbStatePostcode
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        // if (isFieldEmpty($addressPostCode)) {
        //     $addressPostCode
        //         .parent().addClass('incomplete')
        //         .find('.error').slideDown({
        //         duration: 500,
        //         easing: 'easeOutExpo',
        //         queue: false
        //     });

        //     _isInvalid.push(0);
        // }

        // if (isFieldEmpty($addressSuburb)) {
        //     $addressSuburb
        //         .parent().addClass('incomplete')
        //         .find('.error').slideDown({
        //         duration: 500,
        //         easing: 'easeOutExpo',
        //         queue: false
        //     });

        //     _isInvalid.push(0);
        // }

        // if (isFieldEmpty($addressState)) {
        //     $addressState
        //         .parent().addClass('incomplete')
        //         .find('.error').slideDown({
        //         duration: 500,
        //         easing: 'easeOutExpo',
        //         queue: false
        //     });

        //     _isInvalid.push(0);
        // }

        if (_isInvalid.length > 0) {
            $('#delivery-details').addClass('error');
            return false;
        } else {
            _isInvalid = [];

            // If there is only 1 payment option, make it selected by default.
            if ($('.payment__list li').length === 1) {
                $('.payment__list li').addClass('selected');
                $('.payment__list li button')
                    .addClass('active')
                    .trigger('click');
            }

            $('#delivery-details').removeClass('error');
            $('#delivery-details').addClass('completed');

            toggleProgressBar(7);
            goToNextSection('#payment-details');

            var prodDetails = productDetails.getSelectedProducts();
            if(isNdis && prodDetails[0].NumberOfOrders > 1) {
                $(".js-pay-now").hide();
            }

            // displaySummary('.summary--delivery-details');
            // displayDeliverySummary();

            var $js_display_summary  = $('.js-display-summary'),
                $summary = $('.summary-dashboard'),
                $label = $('.show-summary__link-label');

            $js_display_summary.toggleClass('active');

            if ($js_display_summary.is('.active')) {
                $label.text('Hide summary');
            } else {
                $label.text('Show summary');
            }

            $summary.slideToggle();
        }
    });


    $('.js-set-delivery').on('click', function(e) {
        e.preventDefault();

        if (isAnim) {
            return false;
        }

        _isInvalid = [];

        if (isFieldEmpty($addressLine1)) {
            $addressLine1
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (isFieldEmpty($suburbStatePostcode)) {
            $suburbStatePostcode
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        // if (isFieldEmpty($addressPostCode)) {
        //     $addressPostCode
        //         .parent().addClass('incomplete')
        //         .find('.error').slideDown({
        //         duration: 500,
        //         easing: 'easeOutExpo',
        //         queue: false
        //     });

        //     _isInvalid.push(0);
        // }

        // if (isFieldEmpty($addressSuburb)) {
        //     $addressSuburb
        //         .parent().addClass('incomplete')
        //         .find('.error').slideDown({
        //         duration: 500,
        //         easing: 'easeOutExpo',
        //         queue: false
        //     });

        //     _isInvalid.push(0);
        // }

        // if (isFieldEmpty($addressState)) {
        //     $addressState
        //         .parent().addClass('incomplete')
        //         .find('.error').slideDown({
        //         duration: 500,
        //         easing: 'easeOutExpo',
        //         queue: false
        //     });

        //     _isInvalid.push(0);
        // }

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {
            _isInvalid = [];

            // If there is only 1 payment option, make it selected by default.
            if ($('.payment__list li').length === 1) {
                $('.payment__list li').addClass('selected');
                $('.payment__list li button')
                    .addClass('active')
                    .trigger('click');
            }

            $(this).removeClass('error');
            $('#delivery-details').addClass('completed');

            //#83483 - Client requested that 1 of 1 orders in create regimen view 
            //have client notifications disabled by default
            if (productDetails.isThereOneOrLessOrders()) {
                $disableClientNotifications.parent().toggleClass('checked');
                $disableClientNotifications.attr("checked", "checked");
            }

            toggleProgressBar(7);
            goToNextSection('#payment-details');

            summaryDetails.displaySummary('delivery');
            productDetails.getAllProducts(true, false);
            if(isNdis) {
                isNdisPayLater(true);
            }
        }
    });

    $('.form--delivery-details input').on('blur', function () {
        summaryDetails.displaySummary('delivery');
    });

    //TODO refactor: this should have been removed, check why still here
    let displayDeliverySummary = function (){

        values = {
            "DeliveryNotes" : $('#DeliveryNotes option:selected').text(),
            "AddressLine1" : $addressLine1.val(),
            "AddressLine2" : $addressLine2.val(),
            "AddressPostCode" : $addressPostCode.val(),
            "AddressSuburb" : $addressSuburb.val(),
            "AddressState" : $addressState.val()
        };
    }

    let displayContactSummary = function() {
        values = {
            'PhoneNumber': $primaryNumber.val(),
            'SecondaryNumber': $secondaryNumber.val() == '' ? null : $secondaryNumber.val(),
            'EmailAddress': $emailAddress.val() == '' ? null : $emailAddress.val(),
            'Carer': carerDetails()
        };
    };

    //Update summary if changes occur after completing each form
    //also need a displayDeliveryNotesSummary
    $('body').on('change', '#contact-details.completed input', function(){
        displayContactSummary();
    });

    $('body').on('change', '#delivery-details.completed input', function(){
        displayDeliverySummary();
    });

    //change delivery free mode to All Free
    $allDeliveryFree.on('change', function(e) {

        if ($(this).prop('checked')) {

            if ($firstDeliveryFree.prop('checked')) {
                $firstDeliveryFree
                    .prop('checked', false)
                    .parent().removeClass('checked');
            }
        }

        setDeliveryFee();
    });

    // DHL CS can set the delivery fee: set delivery free for first order.
    $firstDeliveryFree.on('change', function(e){

        if ($(this).prop('checked')) {
            if($allDeliveryFree.prop('checked')){
                $allDeliveryFree
                    .prop('checked', false)
                    .parent().removeClass('checked');
            }
        }

        setDeliveryFee();
    });

    // DHL CS can set the delivery fee: change delivery free for all orders
    $('body').on('change', $isEligibleForFreeDelivery, function(e){
        e.stopImmediatePropagation();

        setDeliveryFee();
    });

    $('body').on('change', $addressState, function(e){
        e.stopImmediatePropagation();

        setDeliveryFee();
    });

    $('body').on('change', $firstDeliveryCartons, function(e){
        e.stopImmediatePropagation();

        setDeliveryFee();
    });

    //TODO: when time, consider reviewing all the following CTA
    // eg js-pay-now and js-pay-continue could be consolidated
    // the only difference is the function they perform, if successful

    $('.js-pay-now').on('click', function (e) {
        e.preventDefault();

        if(!isPaymentSelected($(this)))
            return false;

        isPayNow = true;
        $selectCtaPayment = $(this);

        if(isStockToReview()){
            let soh = new SohModal();

            $.when(
                soh._isInStock()
            ).then(function(data){
				let addressState = $('#administrative_area_level_1').val();
				if(data.IsInStock && addressState == "WA" && data.ProductsOutOfStockLocally.length > 0) {
                    //let soh modal handle this..
                } else if(data.IsInStock ) {
                    recurringRegimen($(this));
                }
            });
        }
        else
            recurringRegimen($(this));
    });

    $('.js-pay-later').on('click', function (e) {
        e.preventDefault();

        //TODO make reusable (for each submission button on creating regimen)
        if($(this).hasClass('disabled'))
          return false;

        if(!isPaymentSelected($(this)))
            return false;

        $(this).addClass('disabled');

        isPayNow = false;
        setRegimenValues(isPayNow, $(this));
    });

    $('.js-pay-continue').on('click', function (e) {
        e.preventDefault();

        let $this = $(this);

        //TODO make reusable (for each submission button on creating regimen)
        if($(this).hasClass('disabled'))
        {
          return false;
        }

        if(!isPaymentSelected($(this)))
            return false;

        $(this).addClass('disabled');

        isPayNow = true;
        $selectCtaPayment = $(this);

        if(isStockToReview()){
            let soh = new SohModal();

            $.when(
                soh._isInStock()
            ).done(function(data){
                if(data.IsInStock){
                  setRegimenValues(isPayNow, $this);
                }

            });
        }
        else{
          setRegimenValues(isPayNow, $this);
        }

    });

    $(document).on('click', '.js-ignore-soh', function (e) {
        e.preventDefault();

        //TODO make reusable (for each submission button on creating regimen)
        if($(this).hasClass('disabled'))
          return false;

        $(this).addClass('disabled');

        $.fancybox.close();

        isPayNow = true;
        isSkipStockCheck = true;
        setRegimenValues(isPayNow, $(this));
    });

    /* when overriding first order, continously check SOH
    ** by triggering the cta previously clicked
    */
    $('.js-override-checked-order').on('click', function (e) {
        e.preventDefault();

        overrideCheckedOrderClicked = true;
        //TODO make reusable (for each submission button on creating regimen)
        if($(this).hasClass('disabled'))
          return false;

        $(this).addClass('disabled');
        $selectCtaPayment.trigger('click');
    });
});


let recurringRegimen = function(clickedButton) {

    let $hospitalPayBtn = $('.js-toggle-hospital'),
        isMobileDevice = Modernizr.mq('(max-width: 767px)'),
        $orders = $('.form--products .receipt--table tbody tr'),
        numOrders = $orders.length;

    // if Hospital pay, popup is not needed
    if ($hospitalPayBtn.is('.active')) {
        return false;
    }

    if (numOrders > 1) {
        $.fancybox.open('#consent-recurring', {
            autoSize: false,
            closeBtn: false,
            fitToView: false,
            height: isMobileDevice == true ? 300 : 200,
            width: isMobileDevice == true ? 250 : 500,
            padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
            type: 'inline',
            wrapCSS: 'modal',
            helpers: {
                overlay: {
                    locked: true
                }
            }
        });
    }
    else {
        setRegimenValues(isPayNow, clickedButton);
    }

}

//need to be outside of fancyBox call otherwise it will call regimen API multiple times
$('.js-confirm-recurring').on('click', function (e){
    e.preventDefault();

    //TODO make reusable (for each submission button on creating regimen)
    if($(this).hasClass('disabled'))
      return false;

    $(this).addClass('disabled');

    $.fancybox.close();

    setRegimenValues(isPayNow, $(this));

});

$('.js-cancel-recurring').on('click', function (e){
    e.preventDefault();

    $.fancybox.close();
});

/* Prepare values to send when calling the API. Notes:
** - $isFirstFree: if not in the markup, send "false" value instead of null
** - stock will be checked only it is Pay Now
*/
let setRegimenValues = function(isPayNow, clickedButton){
    let $dieticiansPatientNotes = $('#DieticiansPatientNotes'),
        $hcpNotes = $('#HcpNotes'),
        $hcpCsNotes = $('#HcpCsNotes'),
        $csNotes = $('#CsNotes'),
        $poNumberList = $('.PoNumber__list'),
        $poContainer = $('.po-number__container'),
        $customPoNumber = $('#CustomPoNumber'),
        $isFirstFree = $('#IsFirstOrderFree'),
        // Define where to display ajax errors
        $errorContainer = $('.js-error--set-regimen'),
        institutionIdVal = '',
        hcpWorkplaceVal = '',
        firstorder;

    let productDetails = new ProductDetails(),
        isOrderOverriden = $('.form--order-override').is(':visible'),
        overrideorder;

    if(isOrderOverriden)
        firstorder = new FirstOrder();

    ($startLater.val())
        ? startDate = $startDateInput.val()
        : startDate = moment().format('DD-MM-YYYY');

    // Purchase Order Number is mandatory only if payment option is either "Institution Pays" or "Co-pays"
    if ($poContainer.is(':visible')){

        // values from the list
        if(isFieldEmpty($poNumberList)){
            displayInputError($poNumberList, false);
            clickedButton.removeClass('disabled');
            return false;
        }
    }
    let poNumber = new PoNumber();

    if(!poNumber.isValidPONumber('newRegimen')){
      clickedButton.removeClass('disabled');
      return false;
    }

    loader.fadeIn();

    if ($dashboardCustService.length) {
        institutionIdVal = $institutionId.val();
        hcpWorkplaceVal = $hcpWorkplaceId.val();
    }
    else{
        institutionIdVal = $institutionId.val();
    }

    let prods = productDetails.getSelectedProducts();

    dataParams = {
        "InstitutionId" : institutionIdVal,
        "HcpWorkplaceId" : hcpWorkplaceVal,
        "Client": {
            'Carers': $patientHaveCarer.is(":checked") ? carerDetails() : null,
            "Details": {
                'Title' : $title.val(),
                'FirstName': $firstName.val(),
                'LastName': $lastName.val(),
                'Dob' : {
                    'Day' : $dobDay.val(),
                    'Month' : $dobMonth.val(),
                    'Year' : $dobYear.val()
                },
                'Gender': $gender.val(),
                'ClientUr': $clientUR.val(),
                'PrimaryPhoneNumber': $primaryNumber.val(),
                'SecondaryPhoneNumber': $secondaryNumber.val() == '' ? null : $secondaryNumber.val(),
                'EmailAddress': $emailAddress.val() == '' ? null : $emailAddress.val(),
                'NDISEligibility': $ndisEligibility.val()
            },
            'IsDoNotCallOpted': $doNotCall.prop('checked'),
            "AgreesToPrivacy": 1,
            "DoesClientHaveCarer": $patientHaveCarer.prop("checked"),
            "InstitutionId": $institutionId.val(),
            "ClientId": $clientId.val(),
            "Address": {
                "Address1" : $addressLine1.val(),
                "Address2" : $addressLine2.val(),
                "Suburb" : $addressSuburb.val(),
                "PostCode" : $addressPostCode.val(),
                "State" : $addressState.val(),
                "AdditionalNote": isFieldEmpty($addressAdditionalNotes) ? null : $addressAdditionalNotes.val()
            }
        },
        "RegimenNotes": {
            "DieticiansClientNotes" : isFieldEmpty($dieticiansPatientNotes) ? null : $dieticiansPatientNotes.val(),
            "HcpNote": isFieldEmpty($hcpNotes) ? null : $hcpNotes.val(),
            "HcpAndCustomerSupportNote": isFieldEmpty($hcpCsNotes) ? null : $hcpCsNotes.val(),
            "CustomerSupportNote": isFieldEmpty($csNotes) ? null : $csNotes.val()
        },
        "Phases": prods,
        "DeliveryNoteId" : isFieldEmpty($deliveryNotes) ? null : $deliveryNotes.val(),
        "PaymentRuleId": $('.js-toggle-all-free.pay-selected').length == 1  ? null : $('.payment__list li.pay-selected').data('ruleid'),
        "IsPayNow" : isNdis ? false : isPayNow,
        "PurchaseOrderNumber" : $poNumberList.val() == '' ? null : poNumber.getPONumber('newRegimen'),
        "DeliveryFeeType": setDeliveryFeeType(),
        "IsUrgentOrder": $urgentOrder.prop('checked'),
        "CanStartImmediately": $startToday.prop('checked'),
        "StartDate": startDate,
        "RequiresHcpApproval": $requiresHcpApproval.length == 0  ? false : $requiresHcpApproval.prop('checked'),
        "IsFirstOrderFree": $isFirstFree.length == 0  ? false : $isFirstFree.prop('checked'),
        "AreAllOrdersFree": $('.js-toggle-all-free').parent().hasClass('pay-selected')  ? true : false,
        "DisableClientNotifications": $disableClientNotifications.length == 0  ? false : $disableClientNotifications.prop('checked'),
        "FirstOrderOverride": isOrderOverriden ? firstorder.getFirstOrderProducts() : null,
        "SkipStockCheck": isSkipStockCheck
    };

    $.ajax({
        url: '/api/regimens',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        // Comment out for simulation.
        type: 'POST',
        headers: { __RequestVerificationToken: $createRegimenForm.find('input[name=__RequestVerificationToken]').val() },
        data: JSON.stringify(dataParams),
        success: function (data) {
            toaster('Nutrition plan saved successfully. Redirecting.');

            $errorContainer.slideUp({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            window.location.href = data.href;

            loader.fadeOut();
        },
        error: function (error) {
            loader.fadeOut();
            displayErrors(error, $errorContainer );
            clickedButton.removeClass('disabled');
            if(overrideCheckedOrderClicked){
              $('.js-override-checked-order').removeClass('disabled');
              overrideCheckedOrderClicked = false;
            }
        }
    });
};

let setDeliveryFee = function(){
    let $deliverFee = $('.delivery-fee'),
        cartonsFirstOrder = $firstDeliveryCartons.val(),
        isFreeDelivery = $isEligibleForFreeDelivery.val(),
        state = $addressState.val(),
        gst = $gst.val(),
        oneCartonCost,
        twoCartonCost,
        moreCartonCost,
        freeDeliveryThreshold,
        flatDeliveryFee,
        fee,
        adminFeeInCents = parseFloat($('#AdministrationFee').val()),
        deliveryGst = 0,
        deliveryGstIncluded = 0,
        totalGst = 0,
        total = $('.phase--wrapper.active .product-details:first-child .regimen-total__price').text(),
        el,
        productDetails = new ProductDetails(),
        prodGst = productDetails.calculateTotalGst();

    switch (state) {
        case 'ACT':
            el = $('#delivery-costs--ACT');
            break;
        case 'NSW':
            el = $('#delivery-costs--NSW');
            break;
        case 'NT':
            el = $('#delivery-costs--NT');
            break;
        case 'QLD':
            el = $('#delivery-costs--QLD');
            break;
        case 'SA':
            el = $('#delivery-costs--SA');
            break;
        case 'TAS':
            el = $('#delivery-costs--TAS');
            break;
        case 'VIC':
            el = $('#delivery-costs--VIC');
            break;
        case 'WA':
            el = $('#delivery-costs--WA');
            break;
        default:
            return false;
    }

    //if the user changes the DeliveryFeeType, update the value
    let deliveryFeeType = setDeliveryFeeType();
    if (deliveryFeeType !== 0) {
        isFreeDelivery = 'true';
    }

    if ($('.js-toggle-all-free').hasClass('active')){
        isFreeDelivery = 'true';
        adminFeeInCents = 0;
    }

    if($('#IsFirstOrderFree').prop('checked')){
        isFreeDelivery = 'true';
        adminFeeInCents = 0;
    }

    if(_tenderSetting.DeliveryCostType == "Flat") {
        freeDeliveryThreshold = _tenderSetting.FreeDeliveryThreshold;
        flatDeliveryFee = _tenderSetting.FlatDeliveryCost;
    }

    if(flatDeliveryFee > 0) {
        //if free del checkboxes are checked, dont charge del fee
        if(deliveryFeeType == "1" || deliveryFeeType == "2") {
            $deliverFee.text('0');
            $firstRowDelivery.show();
            deliveryGst = 0;
            deliveryGstIncluded = 0;
        } else {
            fee = flatDeliveryFee;
            if(Number(total) >= (freeDeliveryThreshold * .01)) {
                fee = 0;
                deliveryGst = 0;
                deliveryGstIncluded = 0;
            }
        }
    } else {
        if (isFreeDelivery === 'true') {
            $deliverFee.text('0');
            $firstRowDelivery.show();

            deliveryGst = 0;
            deliveryGstIncluded = 0;
        } else {
            $firstRowDelivery.hide();

            oneCartonCost = el.data('one-carton');
            twoCartonCost = el.data('two-carton');
            moreCartonCost = el.data('more-carton');

            if (cartonsFirstOrder == 0) {
                fee = 0;
            } else if (cartonsFirstOrder == 1) {
                fee = oneCartonCost;
            }
            else if (cartonsFirstOrder == 2) {
                fee = twoCartonCost;
            } else{
                fee = moreCartonCost ;
            }
        }
    }

    if(fee > 0){
        // Fees are in cents --> need to convert into dollars
        fee = fee * 0.01;
        deliveryGst = fee * gst;
        deliveryGstIncluded = (fee + deliveryGst).toFixed(2);
    }

    totalGst = (prodGst + deliveryGst + adminFeeInCents * 0.01 * gst).toFixed(2);

    // set delivery fee
    $deliverFee.text(deliveryGstIncluded);
    $receiptDeliveryFee.text(deliveryGstIncluded);

    $paymentDelivery.val(deliveryGstIncluded);

    //set total GST Amount
    $('.receipt--gst-total').text(totalGst);

    // review total in the payment summary
    total = Number(total) + Number(deliveryGstIncluded);
    total = total.toFixed(2);
    $('.form--payment .summary .num').text(total);
    $('.show-summary__tot').text(total);
};

// Toggle progress bar, different from the one in the helpers
function toggleProgressBar(sectionInd) {
    if (!hasCarer && sectionInd == 2) {
        sectionInd = sectionInd + 1;
    }

    if (sectionInd > 1) {
        $('.show-summary__link').show();
    }

    if (sectionInd > 5) {
        $('.show-summary__link .odo').show();
        $('.summary-dashboard--right').show();
    } else {
        $('.show-summary__link .odo').hide();
        $('.summary-dashboard--right').hide();
    }

    $multiStepsNav.find('li:nth-child(' + sectionInd + ')')
        .removeClass('active')
        .next().addClass('current-page__link active');
};


//transition from dashboard layout to create new regimen page
let changeToRegimen = function () {
    $('.regime-status').fadeOut({
        duration: 500,
        easing: 'easeInOutExpo'
    });

    $('.form--patient-details').fadeIn({
        duration: 500,
        easing: 'easeInOutExpo'
    });

    $('.main-nav').slideUp({
        duration: 500,
        easing: 'easeInOutExpo'
    });

    $multiStepsNav.slideDown({
        duration: 500,
        easing: 'easeInOutExpo'
    });
};

let isPaymentSelected = function($button){
    let payment = $('.pay-selected .js-toggle-all-free').length == 1  ? null : $('.payment__list li.pay-selected').data('ruleid'),
        isSelected = false;

    let $errorContainer = $button.siblings('.validation--message');

    if(typeof payment === 'undefined'){
        $errorContainer
            .slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
    }
    else{
        isSelected = true;
        $errorContainer
            .slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
    }

    return isSelected;
};

/*  always check SOH, unless
**  - it is pay later
**  - it needs HPC approval
**  - it starts later */
let isStockToReview = function(){
    //return false;//added to allow hcp to create orders that are out of stock..
    let isStartLater = $startLater.prop('checked'),
        needHcpApproval = $requiresHcpApproval.prop('checked');

    if(isStartLater || needHcpApproval)
        return false;
    else
        return true;
};

// Populate Suggestions on the footer
let populateSuggestions = function () {
    obj = {},
        formSuggestionHtml = '';

    let $errorContainer = $('.js-error--suggestions');
    changeToRegimen();

    if (isFieldEmpty($firstName) && isFieldEmpty($lastName) && isDobEmpty()) {
        $suggestions.removeClass('active');
        return false;
    }

    // call api if all mandatory dropdowns are selected
    dataParams = {
        "institutionId": $institutionId.val(),
        "firstName": $firstName.val(),
        "lastName": $lastName.val(),
        "dobDay" : $dobDay.val(),
        "dobMonth" : $dobMonth.val(),
        "dobYear": $dobYear.val()
    };

    var encodedParams = jQuery.param(dataParams);

    $.ajax({
        url: '/api/clients?' + encodedParams,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'GET',
        success: function (data) {
            _data = data.details;
            _filteredData = _data;

            $errorContainer.slideUp({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            // for prototype simulation only. Not needed for build
            //filter through first name values
            // if (!isFieldEmpty($firstName)) {
            //     _filteredData = $.grep(_data, function (obj){
            //         let firstName = obj.Details.FirstName;

            //         firstName = firstName.toLowerCase();

            //         if (firstName.indexOf($firstName.val().toLowerCase()) != -1) {
            //             return true;
            //         }
            //     });
            // }

            $suggestions.addClass('active');

            if (!_filteredData.length) {
                $suggestions.removeClass('active');
                return false;
            }

            for (let i = 0, l = _filteredData.length; i < l; i++) {
                obj = {
                    "id": _filteredData[i].Id,
                    "ind": _filteredData[i].Index,
                    "name": _filteredData[i].Details.FirstName + " " + _filteredData[i].Details.LastName,
                    "dob": _filteredData[i].Details.Dob.Day  + " " + _filteredData[i].Details.Dob.Month  + " " + _filteredData[i].Details.Dob.Year,
                    "regimens": _filteredData[i].NumberOfActiveRegimens
                };

                if (i < 5) {
                    formSuggestionHtml += formSuggestionTmp(obj)
                }
            }

            $('.form--suggestion').html(formSuggestionHtml);

        },
        error: function (error) {
            loader.fadeOut();
            displayErrors(error, $errorContainer);
        }
    });
};

// Populate the form details
let populateDetails = function (ind) {

    if (_data[ind].Details.Title != null) {
        $title
            .val(_data[ind].Details.Title).change()
            .addClass('readonly')
            .attr('disabled', true)
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Details.FirstName != null) {
        $firstName
            .val(decodeResponse(_data[ind].Details.FirstName))
            .prop('readonly', true)
            .parent()
            .removeClass('incomplete')
            .addClass('readonly')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Details.LastName != null) {
        $lastName
            .val(decodeResponse(_data[ind].Details.LastName))
            .prop('readonly', true)
            .parent()
            .removeClass('incomplete')
            .addClass('readonly')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Details.Dob.Day != null || _data[ind].Details.Dob.Month != null || _data[ind].Details.Dob.Year != null) {
        $dobDay
            .val(decodeResponse(_data[ind].Details.Dob.Day))
            .prop('readonly', true)
            .parent()
            .removeClass('incomplete')
            .addClass('readonly')
            .addClass('complete focus');

        $('.dob .error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        $dobMonth
            .val(decodeResponse(_data[ind].Details.Dob.Month))
            .prop('readonly', true)
            .parent()
            .removeClass('incomplete')
            .addClass('readonly')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        $dobYear
            .val(decodeResponse(_data[ind].Details.Dob.Year))
            .prop('readonly', true)
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .addClass('readonly')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Details.Gender != null) {
        $gender
            .val(_data[ind].Details.Gender).change()
            .addClass('readonly')
            .attr('disabled', true)
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Id != null) {
        $clientId
            .val(decodeResponse(_data[ind].Id));
    }

    if (_data[ind].IsEligibleForFreeDelivery != null) {
        $isEligibleForFreeDelivery
            .val(_data[ind].IsEligibleForFreeDelivery)
            .trigger('change');
    }

    if (_data[ind].Carers != null && _data[ind].Carers.length != 0) {
        hasCarer = true;

        $patientHaveCarer
            .prop('checked', true)
            .parent().addClass('checked');

        $primaryContact.parent().show();

    } else {
        $patientHaveCarer
            .prop('checked', false)
            .parent().removeClass('checked');

        $('.form--carer-details').hide();
    }

    if (_data[ind].Details.IsDoNotCallOpted == true) {

        $doNotCall
            .prop('checked', true)
            .parent().addClass('checked');

    } else {
        $doNotCall
            .prop('checked', false)
            .parent().removeClass('checked');
    }

    if (_data[ind].Details.PrimaryPhoneNumber != null) {
        $primaryNumber
            .val(decodeResponse(_data[ind].Details.PrimaryPhoneNumber))
            .parent()
            .addClass('complete focus');
    }

    if (_data[ind].Details.SecondaryPhoneNumber != null) {
        $secondaryNumber
            .val(decodeResponse(_data[ind].Details.SecondaryPhoneNumber))
            .parent()
            .addClass('complete focus');
    }

    if (_data[ind].Details.ClientUr != null) {
        $clientUR
            .val(decodeResponse(_data[ind].Details.ClientUr))
            .parent()
            .addClass('complete focus');
    }

    if (_data[ind].Details.EmailAddress != null) {
        $emailAddress
            .val(decodeResponse(_data[ind].Details.EmailAddress))
            .parent()
            .addClass('complete focus');
    }

    if (_data[ind].Carers != null) {

        var _carersList = _data[ind].Carers,
            numberOfCarers =  _carersList.length;

        while(numberOfCarers > 1){
            cloneCarerRow();
            numberOfCarers--;
        }

        $.each(_carersList, function(index, carer){

            let $curretRow = $('.carer-details__row').eq(index);

            $curretRow
                .find('.js-remove-carer')
                .remove();

			$curretRow
                .find('.CarerId')
                .val(decodeResponse(carer.Id));

            $curretRow
                .find('.CarerFirstName')
                .val(decodeResponse(carer.FirstName))
                .parent()
                .addClass('complete focus');

            $curretRow
                .find('.CarerLastName')
                .val(decodeResponse(carer.LastName))
                .parent()
                .addClass('complete focus');

            if (carer.PrimaryPhoneNumber != null) {
                $curretRow
                    .find('.CarerPrimaryNumber')
                    .val(decodeResponse(carer.PrimaryPhoneNumber))
                    .parent()
                    .addClass('complete focus');
            }

            if (carer.SecondaryPhoneNumber != null) {
                $curretRow
                    .find('.CarerSecondaryNumber')
                    .val(decodeResponse(carer.SecondaryPhoneNumber))
                    .parent()
                    .addClass('complete focus');
            }

            if (carer.EmailAddress != null) {
                $curretRow
                    .find('.CarerEmailAddress')
                    .val(decodeResponse(carer.EmailAddress))
                    .parent()
                    .addClass('complete focus');
            }

			if (carer.RelationshipToClient != null) {
                $curretRow
                    .find('.CarerRelationshipToClient')
                    .val(carer.RelationshipToClient).change()
                    .parent()
                    .addClass('complete focus');
            }

            if (carer.PrimaryContact === true) {
                isCarerPrimaryContact = true;

                $primaryContact
                    .prop('checked', true)
                    .trigger('change')
                    .parent().addClass('checked');
            }
        });
    }

    if (_data[ind].Address.Address1 != null) {
        $addressLine1
            .val(decodeResponse(_data[ind].Address.Address1))
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Address.Address2 != null) {
        $addressLine2
            .val(decodeResponse(_data[ind].Address.Address2))
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Address.Suburb != null) {
        $addressSuburb
            .val(decodeResponse(_data[ind].Address.Suburb))
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Address.Postcode != null) {
        $addressPostCode
            .val(decodeResponse(_data[ind].Address.Postcode))
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Address.State != null) {
        $addressState
            .val(_data[ind].Address.State)
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Address.AdditionalNote != null) {
        $addressAdditionalNotes
            .val(_data[ind].Address.AdditionalNote)
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }
};

// Reset form
function resetForm() {
    sectionInd = 1;
    isAnim = true;
    isCarerPrimaryContact = false;
    isAccountCreated = false;
    hasCarer = false;

    gsap.to(window, {duration: 1,
        scrollTo: {
            y: 0,
            ease: "expo.inOut"
        },
        onComplete: function () {
            isAnim = false;
        }
    });

    $multiStepsNav
        .find('.current-page__link')
        .removeClass('current-page__link')
        .end()
        .find('.back-to')
        .next().addClass('current-page__link');

    $suggestions.removeClass('active');

    $patientHaveCarer.prop('checked', false)
        .parent().removeClass('checked');

    //TODO: loop instead of repeating?!
    $firstName
        .val('')
        .parent().removeClass('complete focus');

    $lastName
        .val('')
        .parent().removeClass('complete focus');

    $dobDay
        .val('')
        .parent().removeClass('complete focus');

    $dobMonth
        .val('')
        .parent().removeClass('complete focus');

    $dobYear
        .val('')
        .parent().removeClass('complete focus');

    $gender
        .val('')
        .parent().removeClass('complete focus');

    $clientId
        .val('')
        .parent().removeClass('complete focus');

    $deliveryNotes
        .val('')
        .parent().removeClass('complete focus');

    $primaryContact
        .val('')
        .parent().removeClass('complete focus');

    $primaryNumber
        .val('')
        .parent().removeClass('complete focus');

    $secondaryNumber
        .val('')
        .parent().removeClass('complete focus');

    $emailAddress
        .val('')
        .parent().removeClass('complete focus');

    $patientHaveCarer
        .val('')
        .parent().removeClass('complete focus');

    $carerFirstName
        .val('')
        .parent().removeClass('complete focus');

    $carerLastName
        .val('')
        .parent().removeClass('complete focus');

    $carerPrimaryNumber
        .val('')
        .parent().removeClass('complete focus');

    $carerSecondaryNumber
        .val('')
        .parent().removeClass('complete focus');

    $carerEmailAddress
        .val('')
        .parent().removeClass('complete focus');

    $carerRelationshipToClient
        .val('')
        .parent.removeClass('complete focus');

    $addressLine1
        .val('')
        .parent().removeClass('complete focus');

    $addressLine2
        .val('')
        .parent().removeClass('complete focus');

    $addressSuburb
        .val('')
        .parent().removeClass('complete focus');

    $addressPostCode
        .val('')
        .parent().removeClass('complete focus');

    $addressState
        .val('')
        .parent().removeClass('complete focus');

    $('.form--patient-details, .form--contact-details, .form--carer-details, .form--patient-consent').fadeOut({
        duration: 500,
        easing: 'easeOutExpo',
        queue: false,
        complete: function () {
            $('.regime-status').fadeIn({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
        }
    });
};

let setDeliveryFeeType = function() {
    let type;

    if ($allDeliveryFree.prop('checked')) {
        type = $allDeliveryFree.val();
    } else if($firstDeliveryFree.prop('checked')) {
        type = $firstDeliveryFree.val();
    } else {
        type = 0;
    }

    return type;
};


export { changeToRegimen, resetForm, setDeliveryFee};
